// Getters (GET*)
export const GET_LOADING = 'GET_LOADING';

// Mutations (SET*, ADD*, REMOVE*)
// [ACTION]_[PROPERTY]
export const SET_LOADING = 'SET_LOADING';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [ACTION]_[PROPERTY]_[STATUS]
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const ENABLE_LOADING = 'ENABLE_LOADING';
export const DISABLE_LOADING = 'DISABLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/types.js